import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  Email,
  Phone,
  LocationOn,
  Language,
  LinkedIn,
  DragIndicator,
  Reorder
} from "@mui/icons-material";


export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
};

const pageSizeMap = {
  A4: { width: "210mm", height: "297mm" },
  Letter: { width: "216mm", height: "279mm" },
  Legal: { width: "216mm", height: "356mm" },
  A3: { width: "297mm", height: "420mm" },
  Executive: { width: "184mm", height: "267mm" }
};

const defaultData = {
  firstName: "JONATHAN",
  lastName: "PATTERSON",
  currentPosition: "Art Director",
  phone: "+123-456-7890",
  email: "hello@reallygreatsite.com",
  city: "123 Anywhere St., Any City",
  website: "www.reallygreatsite.com",
  profile: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  skills: [
    "Creativity",
    "Digital Marketing",
    "Registration",
    "Critical Thinking",
    "Leadership"
  ]
};

const defaultLeftSectionOrder = ['contact', 'skills', 'languages'];
const defaultRightSectionOrder = [
  'profile', 'education', 'workExperience', 'accomplishments',
  'certifications', 'softwareSkills', 'volunteering', 'interests',
  'websites', 'references', 'additionalInfo'
];

// Replace these icon definitions at the top:
const phoneIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="margin-top:2px;flex-shrink:0;fill:white"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>`;

const emailIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="margin-top:2px;flex-shrink:0;fill:white"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>`;

const locationIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="margin-top:2px;flex-shrink:0;fill:white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`;

const linkedinIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="margin-top:2px;flex-shrink:0;fill:white"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/></svg>`;
const Resume22 = ({
  color = "#0951b0ff",
  nameColor = "#ffffff",
  accentColor = "#e74c3c",
  font = "EB Garamond",
  fontSize = "14px",
  headingSize = "24px",
  fontStyle = "normal",
  sectionSpacing = 50,
  paragraphSpacing = 30,
  lineSpacing = 20,
  topBottomMargin = 40,
  sideMargins = 40,
  paragraphIndent = 0,
  lineWeight = 1,
  pageSize = "A4",
  formData = {},
  photo = "",
  workExperiences = [],
  exporting = false,
  enableDragDrop = true,
  designSettings = {},
  linkedIn = '',
}) => {
  const mergedDesignSettings = {
    color: designSettings.color || color,
    nameColor: designSettings.nameColor || nameColor,
    accentColor: designSettings.accentColor || accentColor,
    font: designSettings.font || font,
    fontSize: designSettings.fontSize || fontSize,
    headingSize: designSettings.headingSize || headingSize,
    fontStyle: designSettings.fontStyle || fontStyle,
    sectionSpacing: designSettings.sectionSpacing !== undefined ? designSettings.sectionSpacing : sectionSpacing,
    paragraphSpacing: designSettings.paragraphSpacing !== undefined ? designSettings.paragraphSpacing : paragraphSpacing,
    lineSpacing: designSettings.lineSpacing !== undefined ? designSettings.lineSpacing : lineSpacing,
    topBottomMargin: designSettings.topBottomMargin !== undefined ? designSettings.topBottomMargin : topBottomMargin,
    sideMargins: designSettings.sideMargins !== undefined ? designSettings.sideMargins : sideMargins,
    paragraphIndent: designSettings.paragraphIndent !== undefined ? designSettings.paragraphIndent : paragraphIndent,
    lineWeight: designSettings.lineWeight !== undefined ? designSettings.lineWeight : lineWeight,
    pageSize: designSettings.pageSize || pageSize
  };

  const page = pageSizeMap[mergedDesignSettings.pageSize] || pageSizeMap.A4;

  const data = {
    ...defaultData,
    ...formData,
    linkedIn: linkedIn || formData.linkedIn || '',
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [pages, setPages] = useState([]);
  const mainContentRef = useRef(null);
  const sidebarContentRef = useRef(null);

  const [educationEntries, setEducationEntries] = useState([]);
  const [savedSkills, setSavedSkills] = useState([]);
  const [savedSummary, setSavedSummary] = useState("");
  const [savedAdditionalInfo, setSavedAdditionalInfo] = useState([]);
  const [savedLanguages, setSavedLanguages] = useState([]);
  const [savedAccomplishments, setSavedAccomplishments] = useState([]);
  const [savedCertifications, setSavedCertifications] = useState([]);
  const [savedReferences, setSavedReferences] = useState([]);
  const [softwareSkills, setSoftwareSkills] = useState([]);
  const [savedVolunteering, setSavedVolunteering] = useState([]);
  const [savedInterests, setSavedInterests] = useState([]);
  const [savedWebsites, setSavedWebsites] = useState([]);
  const [customSections, setCustomSections] = useState({});

  const [leftSectionOrder, setLeftSectionOrder] = useState(defaultLeftSectionOrder);
  const [rightSectionOrder, setRightSectionOrder] = useState(defaultRightSectionOrder);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [dragOverSide, setDragOverSide] = useState(null);
  const [arrangeDialogOpen, setArrangeDialogOpen] = useState(false);

  useEffect(() => {
    const storedEntries = localStorage.getItem("educationEntries");
    if (storedEntries) setEducationEntries(JSON.parse(storedEntries));

    const storedSkills = localStorage.getItem("skills");
    if (storedSkills) setSavedSkills(JSON.parse(storedSkills));

    const storedSummaries = JSON.parse(localStorage.getItem("summaries")) || [];
    if (storedSummaries.length > 0) setSavedSummary(storedSummaries[storedSummaries.length - 1]);

    setSavedAdditionalInfo(JSON.parse(localStorage.getItem("additionalInfo")) || []);
    setSavedLanguages(JSON.parse(localStorage.getItem("languagesList")) || []);
    setSavedAccomplishments(JSON.parse(localStorage.getItem("accomplishmentsList")) || []);
    setSavedCertifications(JSON.parse(localStorage.getItem("certificationsList")) || []);
    setSavedReferences(JSON.parse(localStorage.getItem("referencesList")) || []);
    setSoftwareSkills(JSON.parse(localStorage.getItem("softwareSkills")) || []);
    setSavedVolunteering(JSON.parse(localStorage.getItem("volunteering")) || []);
    setSavedInterests(JSON.parse(localStorage.getItem("interests")) || []);
    setSavedWebsites(JSON.parse(localStorage.getItem("websites")) || []);

    const userId = localStorage.getItem("userId");
    let sectionsData = {};

    if (userId) {
      const currentCustomSections = JSON.parse(localStorage.getItem(`current_custom_sections_${userId}`)) || [];
      if (currentCustomSections.length > 0) {
        currentCustomSections.forEach(sectionName => {
          const userCustomKey = `custom_${userId}_${sectionName}`;
          try {
            const customSectionData = localStorage.getItem(userCustomKey);
            if (customSectionData) {
              const parsedData = JSON.parse(customSectionData);
              const items = parsedData.items || [];
              const validItems = items.filter(item => item && item.trim() !== '');
              if (validItems.length > 0) sectionsData[sectionName] = validItems;
            }
          } catch (error) {
            console.error(`Error loading custom section ${sectionName}:`, error);
          }
        });
      }
    }

    setCustomSections(sectionsData);

    const savedLeftOrder = localStorage.getItem("resume22LeftSectionOrder");
    if (savedLeftOrder) {
      const parsedOrder = JSON.parse(savedLeftOrder);
      setLeftSectionOrder(parsedOrder.filter(s => !s.startsWith('custom_')));
    } else {
      setLeftSectionOrder(defaultLeftSectionOrder);
    }

    const savedRightOrder = localStorage.getItem("resume22RightSectionOrder");
    if (savedRightOrder) {
      const parsedOrder = JSON.parse(savedRightOrder);
      const currentCustomIds = Object.keys(sectionsData).map(name => `custom_${name}`);
      const filtered = parsedOrder.filter(s => !s.startsWith('custom_'));
      setRightSectionOrder([...filtered, ...currentCustomIds]);
    } else {
      const currentCustomIds = Object.keys(sectionsData).map(name => `custom_${name}`);
      setRightSectionOrder([...defaultRightSectionOrder, ...currentCustomIds]);
    }
  }, []);

  useEffect(() => {
    if (leftSectionOrder.length > 0) {
      localStorage.setItem("resume22LeftSectionOrder", JSON.stringify(leftSectionOrder));
    }
  }, [leftSectionOrder]);

  useEffect(() => {
    if (rightSectionOrder.length > 0) {
      localStorage.setItem("resume22RightSectionOrder", JSON.stringify(rightSectionOrder));
    }
  }, [rightSectionOrder]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId && Object.keys(customSections).length > 0) {
      const currentCustomIds = Object.keys(customSections).map(name => `custom_${name}`);
      const filteredRight = rightSectionOrder.filter(s => !s.startsWith('custom_'));
      const newRight = [...filteredRight, ...currentCustomIds];
      if (JSON.stringify(newRight) !== JSON.stringify(rightSectionOrder)) {
        setRightSectionOrder(newRight);
        localStorage.setItem("resume22RightSectionOrder", JSON.stringify(newRight));
      }
      const filteredLeft = leftSectionOrder.filter(s => !s.startsWith('custom_'));
      if (JSON.stringify(filteredLeft) !== JSON.stringify(leftSectionOrder)) {
        setLeftSectionOrder(filteredLeft);
        localStorage.setItem("resume22LeftSectionOrder", JSON.stringify(filteredLeft));
      }
    } else if (userId && Object.keys(customSections).length === 0) {
      const filteredRight = rightSectionOrder.filter(s => !s.startsWith('custom_'));
      if (filteredRight.length !== rightSectionOrder.length) {
        setRightSectionOrder(filteredRight);
        localStorage.setItem("resume22RightSectionOrder", JSON.stringify(filteredRight));
      }
      const filteredLeft = leftSectionOrder.filter(s => !s.startsWith('custom_'));
      if (filteredLeft.length !== leftSectionOrder.length) {
        setLeftSectionOrder(filteredLeft);
        localStorage.setItem("resume22LeftSectionOrder", JSON.stringify(filteredLeft));
      }
    }
  }, [customSections]);

  const formatDate = (month, year) => {
    if (!month || !year) return "";
    return `${month} ${year}`;
  };

  const handleLeftDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', JSON.stringify({ index, side: 'left', sectionId: leftSectionOrder[index] }));
    e.currentTarget.style.opacity = '0.5';
  };

  const handleRightDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', JSON.stringify({ index, side: 'right', sectionId: rightSectionOrder[index] }));
    e.currentTarget.style.opacity = '0.5';
  };

  const handleDragOver = (e, index, side) => {
    e.preventDefault();
    setDragOverIndex(index);
    setDragOverSide(side);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOverIndex(null);
    setDragOverSide(null);
  };

  const handleLeftDrop = (e, targetIndex) => {
    e.preventDefault();
    const dropData = JSON.parse(e.dataTransfer.getData('text/plain'));
    const { index: sourceIndex, side: sourceSide, sectionId } = dropData;
    if (sourceSide === 'left' && sourceIndex !== targetIndex) {
      const newOrder = [...leftSectionOrder];
      const [moved] = newOrder.splice(sourceIndex, 1);
      newOrder.splice(targetIndex, 0, moved);
      setLeftSectionOrder(newOrder);
    } else if (sourceSide === 'right') {
      const newLeft = [...leftSectionOrder];
      const newRight = [...rightSectionOrder];
      newRight.splice(sourceIndex, 1);
      newLeft.splice(targetIndex, 0, sectionId);
      setLeftSectionOrder(newLeft);
      setRightSectionOrder(newRight);
    }
    setDragOverIndex(null);
    setDragOverSide(null);
    e.currentTarget.style.opacity = '1';
    setTimeout(() => paginateContent(), 100);
  };

  const handleRightDrop = (e, targetIndex) => {
    e.preventDefault();
    const dropData = JSON.parse(e.dataTransfer.getData('text/plain'));
    const { index: sourceIndex, side: sourceSide, sectionId } = dropData;
    if (sourceSide === 'right' && sourceIndex !== targetIndex) {
      const newOrder = [...rightSectionOrder];
      const [moved] = newOrder.splice(sourceIndex, 1);
      newOrder.splice(targetIndex, 0, moved);
      setRightSectionOrder(newOrder);
    } else if (sourceSide === 'left') {
      const newLeft = [...leftSectionOrder];
      const newRight = [...rightSectionOrder];
      newLeft.splice(sourceIndex, 1);
      newRight.splice(targetIndex, 0, sectionId);
      setLeftSectionOrder(newLeft);
      setRightSectionOrder(newRight);
    }
    setDragOverIndex(null);
    setDragOverSide(null);
    e.currentTarget.style.opacity = '1';
    setTimeout(() => paginateContent(), 100);
  };

  const handleDragEnd = (e) => {
    setDragOverIndex(null);
    setDragOverSide(null);
    e.currentTarget.style.opacity = '1';
  };

  const resetLeftSectionOrder = () => setLeftSectionOrder(defaultLeftSectionOrder);
  const resetRightSectionOrder = () => setRightSectionOrder(defaultRightSectionOrder);
  const resetAllSectionOrder = () => {
    setLeftSectionOrder(defaultLeftSectionOrder);
    setRightSectionOrder(defaultRightSectionOrder);
  };

  const getSectionTitle = (sectionId) => {
    const titles = {
      'contact': 'Contact', 'skills': 'Skills', 'languages': 'Languages',
      'profile': 'Profile Info', 'education': 'Education', 'workExperience': 'Work Experience',
      'accomplishments': 'Accomplishments', 'certifications': 'Certifications',
      'softwareSkills': 'Software Skills', 'volunteering': 'Volunteering',
      'interests': 'Interests', 'websites': 'Websites', 'references': 'References',
      'additionalInfo': 'Additional Information'
    };
    if (sectionId.startsWith('custom_')) return sectionId.replace('custom_', '').toUpperCase();
    return titles[sectionId] || sectionId;
  };

  const renderDragPanel = (side, sections) => (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        <DragIndicator sx={{ mr: 1 }} />
        {side === 'left' ? 'Left Side' : 'Right Side'} Sections
        <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>({sections.length} sections)</Typography>
      </Typography>
      <Box sx={{ maxHeight: 400, overflow: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
        {sections.length > 0 ? sections.map((sectionId, index) => (
          <Paper key={sectionId} draggable
            onDragStart={(e) => side === 'left' ? handleLeftDragStart(e, index) : handleRightDragStart(e, index)}
            onDragOver={(e) => handleDragOver(e, index, side)}
            onDragLeave={handleDragLeave}
            onDrop={(e) => side === 'left' ? handleLeftDrop(e, index) : handleRightDrop(e, index)}
            onDragEnd={handleDragEnd}
            sx={{ p: 2, mb: 1, display: 'flex', alignItems: 'center', backgroundColor: dragOverIndex === index && dragOverSide === side ? '#f0f0f0' : 'white', boxShadow: dragOverIndex === index && dragOverSide === side ? 2 : 1, cursor: 'grab', '&:active': { cursor: 'grabbing' }, transition: 'all 0.2s ease' }}
          >
            <DragIndicator color="action" />
            <Typography sx={{ ml: 1, flexGrow: 1 }}>{getSectionTitle(sectionId)}</Typography>
            <Typography variant="body2" color="textSecondary">{index + 1}</Typography>
          </Paper>
        )) : (
          <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
            No sections. Drag sections from the other side.
          </Typography>
        )}
      </Box>
      <Button onClick={side === 'left' ? resetLeftSectionOrder : resetRightSectionOrder} variant="outlined" size="small" sx={{ mt: 1 }}>
        Reset {side === 'left' ? 'Left' : 'Right'} Order
      </Button>
    </Box>
  );

  // ✅ Font styles - SVG tags preserve பண்றோம்
  const addFontStylesToHTML = (htmlContent) => {
    return htmlContent
      .replace(/<div(?![^>]*style=)/g, `<div style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.fontSize}; line-height: ${mergedDesignSettings.lineSpacing}px;"`)
      .replace(/<p/g, `<p style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.fontSize}; line-height: ${mergedDesignSettings.lineSpacing}px; margin-bottom: ${mergedDesignSettings.paragraphSpacing}px;"`)
      .replace(/<h1/g, `<h1 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<h2/g, `<h2 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<h3/g, `<h3 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<h4/g, `<h4 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<h5/g, `<h5 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<h6/g, `<h6 style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.headingSize}; margin: 0 0 ${mergedDesignSettings.paragraphSpacing}px 0;"`)
      .replace(/<span/g, `<span style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle};"`)
      .replace(/<li/g, `<li style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; font-size: ${mergedDesignSettings.fontSize}; line-height: ${mergedDesignSettings.lineSpacing}px; margin-bottom: ${mergedDesignSettings.paragraphSpacing / 2}px;"`)
      .replace(/<ul/g, `<ul style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; margin-bottom: ${mergedDesignSettings.paragraphSpacing}px;"`)
      .replace(/<ol/g, `<ol style="font-family: ${mergedDesignSettings.font}; font-style: ${mergedDesignSettings.fontStyle}; margin-bottom: ${mergedDesignSettings.paragraphSpacing}px;"`);
  };

  // ✅ Contact section HTML string - icons white color la hardcode
  const getContactHTML = (fontFamily, fontSize, fontStyle, sectionSpacing, headingSize, accentColor, phone, email, city, linkedInVal) => {
    return `
      <div class="resume-section" style="margin-bottom:${sectionSpacing}px;">
        <div style="margin-bottom:24px; margin-top:32px; font-family:${fontFamily};">
          <div style="font-weight:bold; margin-bottom:8px; color:#ecf0f1; font-size:${headingSize}; border-bottom:2px solid ${accentColor}; padding-bottom:4px; display:inline-block; margin-top:64px; font-family:${fontFamily}; font-style:${fontStyle};">
            CONTACT
          </div>
          <div style="display:flex; flex-direction:column; gap:12px; margin-top:8px;">
            <div style="display:flex; align-items:flex-start; gap:12px;">
              ${phoneIconHTML}
              <span style="color:white; font-size:${fontSize}; font-family:${fontFamily}; font-style:${fontStyle}; word-break:break-all;">${phone}</span>
            </div>
            <div style="display:flex; align-items:flex-start; gap:12px;">
              ${emailIconHTML}
              <span style="color:white; font-size:${fontSize}; font-family:${fontFamily}; font-style:${fontStyle}; word-break:break-all;">${email}</span>
            </div>
            <div style="display:flex; align-items:flex-start; gap:12px;">
              ${locationIconHTML}
              <span style="color:white; font-size:${fontSize}; font-family:${fontFamily}; font-style:${fontStyle}; word-break:break-all;">${city}</span>
            </div>
            ${linkedInVal ? `
            <div style="display:flex; align-items:flex-start; gap:12px;">
              ${linkedinIconHTML}
              <span style="color:white; font-size:${fontSize}; font-family:${fontFamily}; font-style:${fontStyle}; word-break:break-all;">${linkedInVal}</span>
            </div>` : ''}
          </div>
        </div>
      </div>
    `;
  };

  // ✅ Left sidebar - React components use பண்றோம் (measure-க்கு மட்டும்)
  const renderLeftSectionContent = (sectionId) => {
    switch (sectionId) {
      case 'contact':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, mt: 4, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#ecf0f1', fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${mergedDesignSettings.accentColor}`, pb: 0.5, display: 'inline-block', mt: 8, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                CONTACT
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                  <Typography sx={{ color: "white", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.phone}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                  <Typography sx={{ color: "white", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.email}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  <Typography sx={{ color: "white", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.city}</Typography>
                </Box>
                {data.linkedIn && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                    </svg>
                    <Typography sx={{ color: "white", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.linkedIn}</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </div>
        );

      case 'skills':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#ecf0f1', fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${mergedDesignSettings.accentColor}`, pb: 0.5, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                SKILLS
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, fontFamily: mergedDesignSettings.font }}>
                {(savedSkills.length > 0 ? savedSkills : data.skills).map((skill, index) => (
                  <Chip key={index} label={typeof skill === 'object' ? skill.name : skill} size="small"
                    sx={{ mb: 1, backgroundColor: mergedDesignSettings.accentColor, color: 'white', fontWeight: 'bold', fontSize: '0.75rem', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }} />
                ))}
              </Box>
            </Box>
          </div>
        );

      case 'languages':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#ecf0f1', fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${mergedDesignSettings.accentColor}`, pb: 0.5, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                LANGUAGES
              </Typography>
              {(savedLanguages.length > 0 ? savedLanguages : []).map((lang, index) => (
                <Box key={index} sx={{ mb: 1.5, fontFamily: mergedDesignSettings.font }}>
                  <Typography sx={{ fontWeight: 'bold', color: '#ecf0f1', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                    {typeof lang === 'object' ? lang.language || lang.name : lang}
                  </Typography>
                  {typeof lang === 'object' && lang.level && (
                    <Typography sx={{ color: '#bdc3c7', fontStyle: 'italic', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font }}>
                      {lang.level}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          </div>
        );

      default:
        return renderRightSectionContent(sectionId, true);
    }
  };

  const renderRightSectionContent = (sectionId, inSidebar = false) => {
    const textColor = inSidebar ? "white" : "#34495e";
    const accentBorderColor = inSidebar ? "#ecf0f1" : mergedDesignSettings.accentColor;

    switch (sectionId) {
      case 'profile':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
              PROFILE INFO
            </Typography>
            <Typography sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, lineHeight: 1.6, color: textColor, textAlign: 'justify', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
              {savedSummary || data.profile}
            </Typography>
          </div>
        );

      case 'education':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${accentBorderColor}`, pb: 0.5, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                EDUCATION
              </Typography>
              {educationEntries.length > 0 ? educationEntries.map((edu, index) => {
                if (edu.educationLevel) {
                  if (edu.educationLevel === "school") {
                    return (
                      <Box key={index} sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {`${edu.standard} Standard`} {edu.stream ? `- ${edu.stream}` : ''}
                        </Typography>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {edu.schoolName} {edu.schoolLocation ? `(${edu.schoolLocation})` : ''}
                        </Typography>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {edu.percentage ? `Percentage: ${edu.percentage}%` : ''}
                        </Typography>
                      </Box>
                    );
                  } else {
                    return (
                      <Box key={index} sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {edu.degreeName} {edu.specialization ? `- ${edu.specialization}` : ''}
                        </Typography>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {edu.collegeName} {edu.collegeLocation ? `(${edu.collegeLocation})` : ''}
                        </Typography>
                        <Typography sx={{ color: textColor, fontStyle: 'italic', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font }}>
                          {formatDate(edu.gradMonth, edu.gradYear)}
                        </Typography>
                        <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                          {edu.programType ? `${edu.programType}` : ''}
                          {edu.cgpa ? (edu.programType ? ` | CGPA: ${edu.cgpa}` : `CGPA: ${edu.cgpa}`) : ''}
                          {edu.grade ? (edu.cgpa || edu.programType ? ` | Grade: ${edu.grade}` : `Grade: ${edu.grade}`) : ''}
                        </Typography>
                        {edu.additionalCoursework && (
                          <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                            {edu.additionalCoursework}
                          </Typography>
                        )}
                      </Box>
                    );
                  }
                } else {
                  return (
                    <Box key={index} sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
                      <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                        {edu.degree} {edu.fieldOfStudy ? `- ${edu.fieldOfStudy}` : ''}
                      </Typography>
                      <Typography sx={{ color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                        {edu.schoolName}
                      </Typography>
                      <Typography sx={{ color: textColor, fontStyle: 'italic', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font }}>
                        {formatDate(edu.gradMonth, edu.gradYear)}
                      </Typography>
                    </Box>
                  );
                }
              }) : (
                <Typography sx={{ color: '#bdc3c7', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                  No education entries added yet.
                </Typography>
              )}
            </Box>
          </div>
        );

      case 'workExperience':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
              WORK EXPERIENCE
            </Typography>
            <Box sx={{ mt: 2, fontFamily: mergedDesignSettings.font }}>
              {workExperiences && workExperiences.length > 0 ? workExperiences.map((work, index) => (
                <Box key={index} sx={{ mb: 2, pl: 2, borderLeft: `3px solid ${accentBorderColor}`, position: 'relative', fontFamily: mergedDesignSettings.font }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, fontFamily: mergedDesignSettings.font }}>
                    <Typography sx={{ fontWeight: 'bold', color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                      {work.jobTitle} @ {work.employer}
                    </Typography>
                    <Typography sx={{ color: accentBorderColor, fontWeight: 'bold', backgroundColor: inSidebar ? 'rgba(255,255,255,0.1)' : '#f9f9f9', px: 1, py: 0.5, borderRadius: 1, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                      {formatDate(work.startMonth, work.startYear)} - {work.current ? "Present" : formatDate(work.endMonth, work.endYear)}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontWeight: 'bold', mb: 1, color: textColor, fontStyle: 'italic', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font }}>
                    {work.companyName} | {work.location}
                  </Typography>
                  {work.description && (
                    <Box sx={{ mt: 1, lineHeight: 1.6, color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}
                      dangerouslySetInnerHTML={{
                        __html: work.description
                          .replace(/\*\*(.*?)\*\*/g, `<strong style="font-family:${mergedDesignSettings.font};font-weight:bold;">$1</strong>`)
                          .replace(/\*(.*?)\*/g, `<em style="font-family:${mergedDesignSettings.font};font-style:italic;">$1</em>`)
                          .replace(/<u>(.*?)<\/u>/g, `<u style="font-family:${mergedDesignSettings.font};">$1</u>`)
                          .replace(/\n/g, `<br/>`)
                      }}
                    />
                  )}
                </Box>
              )) : (
                <Typography sx={{ fontSize: mergedDesignSettings.fontSize, color: inSidebar ? '#bdc3c7' : '#7f8c8d', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                  No work experiences added yet.
                </Typography>
              )}
            </Box>
          </div>
        );

      case 'accomplishments':
        return savedAccomplishments.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>ACCOMPLISHMENTS</Typography>
              {savedAccomplishments.map((acc, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }} whiteSpace="pre-line">{acc}</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'certifications':
        return savedCertifications.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>CERTIFICATIONS</Typography>
              {savedCertifications.map((cert, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>{cert.name} – {cert.provider} ({cert.year})</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'softwareSkills':
        return softwareSkills.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>SOFTWARE SKILLS</Typography>
              {softwareSkills.map((skill, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>{skill.name} — {skill.level}%</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'volunteering':
        return savedVolunteering.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>VOLUNTEERING</Typography>
              {savedVolunteering.map((vol, index) => (
                <Box key={index} sx={{ mb: 1, fontFamily: mergedDesignSettings.font }}>
                  <Typography sx={{ fontSize: mergedDesignSettings.fontSize, fontWeight: "bold", fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>{vol.subtopic}</Typography>
                  <Typography sx={{ fontSize: mergedDesignSettings.fontSize, color: inSidebar ? '#bdc3c7' : "gray", fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>{vol.fromDate} - {vol.toDate}</Typography>
                  <Typography sx={{ fontSize: mergedDesignSettings.fontSize, whiteSpace: "pre-line", mt: 0.5, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>{vol.content}</Typography>
                </Box>
              ))}
            </Box>
          </div>
        ) : null;

      case 'interests':
        return savedInterests.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>INTERESTS</Typography>
              {savedInterests.map((interest, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>• {interest}</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'websites':
        return savedWebsites.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>WEBSITES / PROFILES</Typography>
              {savedWebsites.map((site, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>
                  <a href={site.url && (site.url.startsWith('http') ? site.url : `https://${site.url}`)} target="_blank" rel="noopener noreferrer"
                    style={{ color: inSidebar ? '#90caf9' : mergedDesignSettings.color, textDecoration: 'none', fontFamily: mergedDesignSettings.font }}>
                    {site.name || site.url}
                  </a>
                  {site.addToHeader ? " (Shown in Header)" : ""}
                </Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'references':
        return savedReferences.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>REFERENCES</Typography>
              {savedReferences.map((ref, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }} whiteSpace="pre-line">{ref}</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'additionalInfo':
        return savedAdditionalInfo.length > 0 ? (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 2, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>ADDITIONAL INFORMATION</Typography>
              {savedAdditionalInfo.map((info, index) => (
                <Typography key={index} sx={{ mb: `${mergedDesignSettings.paragraphSpacing}px`, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>{info}</Typography>
              ))}
            </Box>
          </div>
        ) : null;

      case 'skills':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${accentBorderColor}`, pb: 0.5, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>SKILLS</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, fontFamily: mergedDesignSettings.font }}>
                {(savedSkills.length > 0 ? savedSkills : data.skills).map((skill, index) => (
                  <Chip key={index} label={typeof skill === 'object' ? skill.name : skill} size="small"
                    sx={{ mb: 1, backgroundColor: inSidebar ? mergedDesignSettings.accentColor : mergedDesignSettings.color, color: 'white', fontWeight: 'bold', fontSize: '0.75rem', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }} />
                ))}
              </Box>
            </Box>
          </div>
        );

      case 'contact':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, mt: inSidebar ? 4 : 0, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${accentBorderColor}`, pb: 0.5, display: 'inline-block', mt: inSidebar ? 8 : 0, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                CONTACT
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                  <Typography sx={{ color: inSidebar ? "white" : "#34495e", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.phone}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                  <Typography sx={{ color: inSidebar ? "white" : "#34495e", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.email}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  <Typography sx={{ color: inSidebar ? "white" : "#34495e", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.city}</Typography>
                </Box>
                {data.linkedIn && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ marginTop: '2px', flexShrink: 0 }}>
                      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                    </svg>
                    <Typography sx={{ color: inSidebar ? "white" : "#34495e", fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, wordBreak: 'break-all' }}>{data.linkedIn}</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </div>
        );

      case 'languages':
        return (
          <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
            <Box sx={{ mb: 3, fontFamily: mergedDesignSettings.font }}>
              <Typography component="h3" sx={{ fontWeight: 'bold', mb: 2, color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, fontSize: mergedDesignSettings.headingSize, borderBottom: `2px solid ${accentBorderColor}`, pb: 0.5, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>LANGUAGES</Typography>
              {(savedLanguages.length > 0 ? savedLanguages : []).map((lang, index) => (
                <Box key={index} sx={{ mb: 1.5, fontFamily: mergedDesignSettings.font }}>
                  <Typography sx={{ fontWeight: 'bold', color: textColor, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                    {typeof lang === 'object' ? lang.language || lang.name : lang}
                  </Typography>
                  {typeof lang === 'object' && lang.level && (
                    <Typography sx={{ color: inSidebar ? '#bdc3c7' : '#7f8c8d', fontStyle: 'italic', fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font }}>
                      {lang.level}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          </div>
        );

      default:
        if (sectionId && sectionId.startsWith('custom_')) {
          const customSectionName = sectionId.replace('custom_', '');
          const items = customSections[customSectionName] || [];
          if (items && items.length > 0) {
            return (
              <div className="resume-section" style={{ marginBottom: `${mergedDesignSettings.sectionSpacing}px` }}>
                <Typography component="h3" sx={{ mb: 1, fontSize: mergedDesignSettings.headingSize, fontWeight: "bold", color: inSidebar ? '#ecf0f1' : mergedDesignSettings.color, borderBottom: `2px solid ${accentBorderColor}`, pb: 1, display: 'inline-block', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, margin: 0, marginBottom: '8px' }}>
                  {customSectionName.toUpperCase()}
                </Typography>
                {items.map((item, i) => (
                  <Typography key={i} sx={{ mb: 1, fontSize: mergedDesignSettings.fontSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, color: textColor }}>• {item}</Typography>
                ))}
              </div>
            );
          }
          return null;
        }
        return null;
    }
  };

  const paginateContent = useCallback(() => {
    if (!mainContentRef.current || !sidebarContentRef.current) return;

    const mainSections = Array.from(mainContentRef.current.querySelectorAll('.resume-section'));
    const sidebarSections = Array.from(sidebarContentRef.current.querySelectorAll('.resume-section'));

    const pageHeightInPx = parseFloat(page.height.replace('mm', '')) * 3.78;
    const mainAvailableHeight = pageHeightInPx - (2 * mergedDesignSettings.topBottomMargin);
    const sidebarAvailableHeight = pageHeightInPx - (2 * mergedDesignSettings.topBottomMargin);

    let newPages = [];
    let currentMainPageSections = [];
    let currentSidebarPageSections = [];
    let currentMainHeight = 0;
    let currentSidebarHeight = 0;

    if (mainSections.length === 0 && sidebarSections.length === 0) {
      newPages.push({ main: [], sidebar: [] });
    }

    mainSections.forEach(sectionEl => {
      const sectionHeight = sectionEl.offsetHeight;
      if (currentMainHeight + sectionHeight > mainAvailableHeight && currentMainPageSections.length > 0) {
        newPages.push({ main: currentMainPageSections, sidebar: currentSidebarPageSections });
        currentMainPageSections = [sectionEl];
        currentMainHeight = sectionHeight;
        currentSidebarPageSections = [];
        currentSidebarHeight = 0;
      } else {
        currentMainPageSections.push(sectionEl);
        currentMainHeight += sectionHeight;
      }
    });

    sidebarSections.forEach(sectionEl => {
      const sectionHeight = sectionEl.offsetHeight;
      let targetPageIndex = 0;
      let minHeightDiff = Infinity;

      newPages.forEach((pageObj, index) => {
        const mainHeight = pageObj.main.reduce((sum, s) => sum + s.offsetHeight, 0);
        const sidebarHeight = pageObj.sidebar.reduce((sum, s) => sum + s.offsetHeight, 0);
        const heightDiff = Math.abs(mainHeight - (sidebarHeight + sectionHeight));
        if (heightDiff < minHeightDiff && (sidebarHeight + sectionHeight) <= sidebarAvailableHeight) {
          minHeightDiff = heightDiff;
          targetPageIndex = index;
        }
      });

      if (newPages.length === 0 || minHeightDiff === Infinity) {
        if (currentSidebarHeight + sectionHeight <= sidebarAvailableHeight) {
          currentSidebarPageSections.push(sectionEl);
          currentSidebarHeight += sectionHeight;
        } else {
          newPages.push({ main: currentMainPageSections, sidebar: currentSidebarPageSections });
          currentSidebarPageSections = [sectionEl];
          currentSidebarHeight = sectionHeight;
          currentMainPageSections = [];
          currentMainHeight = 0;
        }
      } else {
        newPages[targetPageIndex].sidebar.push(sectionEl);
      }
    });

    if (currentMainPageSections.length > 0 || currentSidebarPageSections.length > 0) {
      newPages.push({ main: currentMainPageSections, sidebar: currentSidebarPageSections });
    }

    const serializedPages = newPages.map(p => ({
      main: p.main.map(s => s.outerHTML),
      sidebar: p.sidebar.map(s => s.outerHTML),
    }));
    setPages(serializedPages);
  }, [page.height, mergedDesignSettings.topBottomMargin, leftSectionOrder, rightSectionOrder]);

  useEffect(() => {
    const timeoutId = setTimeout(() => paginateContent(), 500);
    return () => clearTimeout(timeoutId);
  }, [paginateContent, educationEntries, savedSkills, savedSummary, workExperiences, savedAdditionalInfo, savedLanguages, savedAccomplishments, savedCertifications, savedReferences, softwareSkills, savedVolunteering, savedInterests, savedWebsites, customSections, leftSectionOrder, rightSectionOrder, mergedDesignSettings]);

const renderSidebarContent = (sidebarSections = []) => {
  if (sidebarSections.length === 0) {
    return <Box sx={{ minHeight: "100%", fontFamily: mergedDesignSettings.font }} />;
  }

  return (
    <Box display="flex" flexDirection="column" sx={{ flexGrow: 1, p: 3, mt: 12, fontFamily: mergedDesignSettings.font }}>
      {sidebarSections.map((section, index) => {
        let sectionHtml = section;

        // Section spacing
        sectionHtml = sectionHtml.replace(
          /<div class="resume-section"/g,
          `<div class="resume-section" style="margin-bottom: ${mergedDesignSettings.sectionSpacing}px;"`
        );

        // 🔥 CRITICAL FIX: For contact section, rebuild it with proper HTML
        if (sectionHtml.includes('CONTACT')) {
          // Extract the phone, email, city, and linkedIn values from the HTML
          const phoneMatch = sectionHtml.match(/<Typography[^>]*>([^<]*)<\/Typography>/);
          const emailMatch = sectionHtml.match(/<Typography[^>]*>([^<]*)<\/Typography>/g);
          
          // Rebuild the contact section with proper HTML string
          return (
            <div
              key={index}
              style={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, fontSize: mergedDesignSettings.fontSize, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}
              dangerouslySetInnerHTML={{
                __html: getContactHTML(
                  mergedDesignSettings.font,
                  mergedDesignSettings.fontSize,
                  mergedDesignSettings.fontStyle,
                  mergedDesignSettings.sectionSpacing,
                  mergedDesignSettings.headingSize,
                  mergedDesignSettings.accentColor,
                  data.phone,
                  data.email,
                  data.city,
                  data.linkedIn || ''
                )
              }}
            />
          );
        }

        // Force SVG icons white in sidebar for other sections
        if (sectionHtml.includes('resume-section')) {
          sectionHtml = sectionHtml.replace(/fill="[^"]*"/g, 'fill="white"');
          sectionHtml = sectionHtml.replace(/fill:[^;"]*/g, 'fill:white');
        }

        // Apply font styles
        sectionHtml = addFontStylesToHTML(sectionHtml);

        return (
          <div
            key={index}
            style={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, fontSize: mergedDesignSettings.fontSize, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}
            dangerouslySetInnerHTML={{ __html: sectionHtml }}
          />
        );
      })}
    </Box>
  );
};

  const renderSidebarContentToMeasure = () => (
    <Box ref={sidebarContentRef} sx={{ visibility: 'hidden', position: 'absolute', fontFamily: mergedDesignSettings.font }}>
      <Box sx={{ p: 3, bgcolor: mergedDesignSettings.color, color: "white", width: "29%", borderTopLeftRadius: '50px', borderTopRightRadius: '50px', borderBottomLeftRadius: '8px', ml: 1, mt: '-300px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 2, fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}>
        {leftSectionOrder.map((sectionId, index) => (
          <React.Fragment key={sectionId}>
            {renderLeftSectionContent(sectionId)}
            {index < leftSectionOrder.length - 1 && (
              <Divider sx={{ bgcolor: "#7f8c8d", my: 2, borderBottomWidth: mergedDesignSettings.lineWeight, fontFamily: mergedDesignSettings.font }} />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );

  const renderMainContentToMeasure = () => (
    <Box ref={mainContentRef} sx={{ visibility: 'hidden', position: 'absolute', fontFamily: mergedDesignSettings.font }}>
      <Box sx={{ p: `${mergedDesignSettings.topBottomMargin}px ${mergedDesignSettings.sideMargins}px`, width: "69%", fontFamily: mergedDesignSettings.font }}>
        {rightSectionOrder.map(sectionId => (
          <React.Fragment key={sectionId}>
            {renderRightSectionContent(sectionId)}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ width: "100%", position: "relative", fontFamily: mergedDesignSettings.font }}>
      {!exporting && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, gap: 2, '@media print': { display: 'none' }, fontFamily: mergedDesignSettings.font }}>
          <IconButton onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))} disabled={currentPage === 0} color="primary"><ChevronLeft /></IconButton>
          <Typography sx={{ mx: 2, fontFamily: mergedDesignSettings.font }}>Page {currentPage + 1} of {Math.max(1, pages.length)}</Typography>
          <IconButton onClick={() => setCurrentPage(prev => Math.min(pages.length - 1, prev + 1))} disabled={currentPage === Math.max(0, pages.length - 1)} color="primary"><ChevronRight /></IconButton>
          {enableDragDrop && (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button onClick={() => setArrangeDialogOpen(true)} variant="contained" startIcon={<Reorder />} color="primary">Arrange Sections</Button>
              <Button onClick={resetAllSectionOrder} variant="outlined" color="secondary" size="small">Reset All Sections</Button>
            </Box>
          )}
        </Box>
      )}

      {renderMainContentToMeasure()}
      {renderSidebarContentToMeasure()}

      <Box id="resume-container" sx={{ fontFamily: mergedDesignSettings.font }}>
        {pages.length > 0 ? pages.map((pageContent, index) => (
          <Box key={index} className="resume-page" sx={{ width: page.width, minHeight: page.height, mx: "auto", bgcolor: "#fff", boxShadow: index === currentPage ? 3 : 0, fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, display: exporting ? 'flex' : (index === currentPage ? 'flex' : 'none'), flexDirection: "column", pageBreakAfter: "always", "@media print": { width: page.width, height: "auto", minHeight: page.height, boxShadow: "none", m: 0, display: 'flex' } }}>
            {index === 0 && (
              <Box sx={{ backgroundColor: mergedDesignSettings.color, color: mergedDesignSettings.nameColor, p: 4, textAlign: 'center', pl: 10, position: 'relative', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '3rem', letterSpacing: 2, lineHeight: 1.2, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                  {data.firstName} {data.lastName}
                </Typography>
                <Typography sx={{ mt: 1, opacity: 0.9, letterSpacing: 1, fontSize: mergedDesignSettings.headingSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
                  {data.currentPosition}
                </Typography>
              </Box>
            )}

            <Grid container sx={{ height: "100%", position: 'relative', minHeight: '800px', fontFamily: mergedDesignSettings.font }}>
              <Grid item xs={12} md={4} sx={{ bgcolor: mergedDesignSettings.color, color: "white", width: "29%", display: "flex", flexDirection: "column", minHeight: page.height, position: 'relative', borderTopLeftRadius: index === 0 ? '50px' : 0, borderTopRightRadius: index === 0 ? '50px' : 0, borderBottomLeftRadius: index === 0 ? '8px' : 0, ml: 1, mt: index === 0 ? '-180px' : 0, boxShadow: index === 0 ? '0 4px 12px rgba(0,0,0,0.15)' : 'none', zIndex: 2, fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, p: `${mergedDesignSettings.topBottomMargin}px ${mergedDesignSettings.sideMargins}px`, "@media print": { bgcolor: mergedDesignSettings.color, color: "white", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact", minHeight: page.height, top: 0, mt: index === 0 ? '-100px' : 0 } }}>
                {index === 0 && (
                  <Box sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', width: 140, height: 140, borderRadius: '50%', border: '6px solid white', backgroundColor: 'white', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', zIndex: 10 }}>
                    <Avatar src={photo || "https://via.placeholder.com/150"} sx={{ width: 128, height: 128, borderRadius: '50%' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', color: mergedDesignSettings.color, fontFamily: mergedDesignSettings.font }}>
                        {data.firstName?.[0]}{data.lastName?.[0]}
                      </Typography>
                    </Avatar>
                  </Box>
                )}
                <div style={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, fontSize: mergedDesignSettings.fontSize, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}>
                  {renderSidebarContent(pageContent.sidebar)}
                </div>
              </Grid>

              <Grid item xs={12} md={8} sx={{ p: `${mergedDesignSettings.topBottomMargin}px ${mergedDesignSettings.sideMargins}px`, width: "69%", fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, "@media print": { p: 2 } }}>
                <div style={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, fontSize: mergedDesignSettings.fontSize, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}>
                  {pageContent.main.map((section, idx) => {
                    let sectionHtml = section;
                    sectionHtml = sectionHtml.replace(/<div class="resume-section"/g, `<div class="resume-section" style="margin-bottom: ${mergedDesignSettings.sectionSpacing}px;"`);
                    return <div key={idx} dangerouslySetInnerHTML={{ __html: addFontStylesToHTML(sectionHtml) }} />;
                  })}
                </div>
              </Grid>
            </Grid>
          </Box>
        )) : (
          <Box className="resume-page" sx={{ width: page.width, minHeight: page.height, mx: "auto", bgcolor: "#fff", boxShadow: 3, fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, display: "flex", flexDirection: "column", "@media print": { width: page.width, height: "auto", minHeight: page.height, boxShadow: "none", m: 0 } }}>
            <Box sx={{ backgroundColor: mergedDesignSettings.color, color: mergedDesignSettings.nameColor, p: 4, textAlign: 'center', pl: 10, position: 'relative', fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>
              <Typography sx={{ fontWeight: 'bold', fontSize: '3rem', letterSpacing: 2, lineHeight: 1.2, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>{data.firstName}</Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: '3rem', letterSpacing: 2, lineHeight: 1.2, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>{data.lastName}</Typography>
              <Typography sx={{ mt: 1, opacity: 0.9, letterSpacing: 1, fontSize: mergedDesignSettings.headingSize, fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>{data.currentPosition}</Typography>
            </Box>
            <Grid container sx={{ height: "100%", position: 'relative', minHeight: '800px', fontFamily: mergedDesignSettings.font }}>
              <Grid item xs={12} md={4} sx={{ bgcolor: mergedDesignSettings.color, color: "white", width: "29%", p: `${mergedDesignSettings.topBottomMargin}px ${mergedDesignSettings.sideMargins}px`, display: "flex", flexDirection: "column", minHeight: page.height, position: 'relative', borderTopLeftRadius: '50px', borderTopRightRadius: '50px', borderBottomLeftRadius: '8px', ml: 1, mt: '-100px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 2, fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, "@media print": { p: 2, bgcolor: mergedDesignSettings.color, color: "white", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact", minHeight: page.height, top: 0, mt: '-100px' } }}>
                <Box sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', width: 140, height: 140, borderRadius: '50%', border: '6px solid white', backgroundColor: 'white', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', zIndex: 10 }}>
                  <Avatar src={photo || "https://via.placeholder.com/150"} sx={{ width: 128, height: 128, borderRadius: '50%' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: mergedDesignSettings.color, fontFamily: mergedDesignSettings.font }}>
                      {data.firstName?.[0]}{data.lastName?.[0]}
                    </Typography>
                  </Avatar>
                </Box>
                <div style={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle, fontSize: mergedDesignSettings.fontSize, lineHeight: `${mergedDesignSettings.lineSpacing}px` }}>
                  {renderSidebarContent()}
                </div>
              </Grid>
              <Grid item xs={12} md={8} sx={{ p: `${mergedDesignSettings.topBottomMargin}px ${mergedDesignSettings.sideMargins}px`, width: "69%", fontFamily: mergedDesignSettings.font, fontSize: mergedDesignSettings.fontSize, fontStyle: mergedDesignSettings.fontStyle, lineHeight: `${mergedDesignSettings.lineSpacing}px`, "@media print": { p: 2 } }}>
                <Typography sx={{ fontFamily: mergedDesignSettings.font, fontStyle: mergedDesignSettings.fontStyle }}>Loading resume...</Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>

      <Dialog open={arrangeDialogOpen} onClose={() => setArrangeDialogOpen(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Reorder sx={{ mr: 1 }} />
            Arrange Resume Sections
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Drag and drop sections to reorder them within each side or move sections between left and right sides.
          </Typography>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3, width: "100%" }}>
            <Box sx={{ flex: 1, width: "50%" }}>{renderDragPanel("left", leftSectionOrder)}</Box>
            <Box sx={{ flex: 1, width: "50%" }}>{renderDragPanel("right", rightSectionOrder)}</Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetAllSectionOrder} color="secondary">Reset All</Button>
          <Button onClick={() => setArrangeDialogOpen(false)} variant="contained">Done</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Resume22;